import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BorrowerValue } from 'app/models/dto/borrower-value.model';
import { differenceInCalendarDays } from 'date-fns';

@Component({
  selector: 'app-signature-request',
  templateUrl: './signature-request.component.html',
  styleUrls: ['./signature-request.component.scss']
})
export class SignatureRequestComponent implements OnInit {

  @Input() signatureRequestSent: boolean;
  @Input() signatureStatus: string;
  @Input() signedDate: string;
  @Input() primarySignatureStatus: string;
  @Input() primarySignedDate: string | null;
  @Input() signatureRequestSending: { sending: boolean, contactId: number | string };
  @Input() contactId: number;
  @Input() isPrimary: number;
  @Input() primaryContactDateSigned: BorrowerValue | null;
  @Output() sendSignatureEvent = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    this.setPrimaryOwnerSignatureStatus();
  }

  sendSignatureRequest() {
    this.sendSignatureEvent.emit();
  }

  setPrimaryOwnerSignatureStatus() {
    if (this.isPrimary && this.primaryContactDateSigned && this.primaryContactDateSigned.value) {
      this.primarySignatureStatus = this.daysAgo(this.primaryContactDateSigned.value) < 30 ? 'Application Signed' : 'Not Signed';
      this.primarySignedDate = this.primarySignatureStatus === 'Application Signed' ? this.primaryContactDateSigned.value : null;
    } else {
      this.primarySignatureStatus = 'Not Signed';
    }
  }

  sending() {
    return this.signatureRequestSending.sending && this.signatureRequestSending.contactId === this.contactId;
  }

  daysAgo(a: string): number {
    return differenceInCalendarDays(new Date(Date.now()), new Date(a));
  }
}
